function SearchFolderData() {
  return {
    url: ""
  }
}

export { SearchFolderData };
